/* ============================================================================
   Registers the "Hours" tab on the request-detail page.
   The panel handles both sides of the workflow itself (designer logs, requester
   approves/adjusts) based on the current user's relationship to the request, so
   the tab is visible to everyone who might act on it.
   ============================================================================ */

import { registerRequestTab, type RequestTabProps } from '../../app/requestTabs';
import HoursPanel from './HoursPanel';

function HoursTab({ requestId }: RequestTabProps) {
  return <HoursPanel requestId={requestId} />;
}

registerRequestTab({
  id: 'hours',
  label: 'Hours',
  order: 30,
  roles: ['Designer', 'Requester', 'Admin', 'SystemAdmin', 'Accounts'],
  component: HoursTab,
});
